import React, { FC, useMemo } from 'react'

import { Txt, Icon } from 'src/components/atoms'
import { CommonContentReleaseToggle } from 'src/components/molecules'

import {
  useCommonContentPage,
  useGetCommonContentPages,
  useGlobalLoading,
  useToast,
  useAuthority,
} from 'src/hooks'
import { CommonContentPageEntity } from 'src/types'

type Props = {
  commonContent: CommonContentPageEntity
  className?: string
}

export const CommonContentReleaseSetting: FC<Props> = ({ commonContent, className }) => {
  const { toCommonContentPageFormEntity, updateCommonContentPage } = useCommonContentPage()
  const { refetch } = useGetCommonContentPages()
  const { displayStandardTextToast, displayErrorTextToast } = useToast()
  const { showGlobalLoading, hideGlobalLoading } = useGlobalLoading()
  const { canWriteCommonContent } = useAuthority()

  const onChange = async (newValue: boolean) => {
    showGlobalLoading()

    const formEntity = toCommonContentPageFormEntity(commonContent)
    const updatedFormEntity = { ...formEntity, isPublic: newValue }

    try {
      await updateCommonContentPage({
        commonContentPageId: commonContent.id,
        formEntity: updatedFormEntity,
      })
      refetch()
      displayStandardTextToast(newValue ? '公開しました' : '非公開にしました')
    } catch {
      displayErrorTextToast('公開設定の変更に失敗しました')
    } finally {
      hideGlobalLoading()
    }
  }

  const existsAsset = useMemo(() => {
    return commonContent.assets.some(asset => asset.contentType !== 'empty')
  }, [commonContent])

  return (
    <div className={className}>
      <div className="tw-flex tw-items-end tw-flex-col">
        <CommonContentReleaseToggle
          disabled={!existsAsset || !canWriteCommonContent}
          isPublic={commonContent.isPublic}
          onChange={onChange}
          className="tw-ml-s-4"
        />
        {!existsAsset && (
          <div className="tw-flex tw-items-center tw-mt-s-3">
            <Txt sizeType="s" className="tw-font-bold tw-mr-s-4 tw-text-cautionYellow-default">
              配信にはコンテンツを１つ以上アップロードが必要
            </Txt>
            <Icon
              size="--r1"
              path="info-triangle/soft/fill"
              className="tw-text-cautionYellow-default"
            />
          </div>
        )}
        {!canWriteCommonContent && (
          <div className="tw-flex tw-items-center tw-mt-s-3">
            <Txt sizeType="s" className="tw-font-bold tw-mr-s-4 tw-text-cautionYellow-default">
              編集権限がありません
            </Txt>
            <Icon
              size="--r1"
              path="info-triangle/soft/fill"
              className="tw-text-cautionYellow-default"
            />
          </div>
        )}
      </div>
    </div>
  )
}
